import getApi from '../../api'
import { TreamentFormResource, Treatment } from '../../model/Treatment'
import { serializeTreatment } from './mapper'

export const createPatientTreatment = (patientId: number, treatment: TreamentFormResource) =>
  getApi().post<Treatment>(`patients/${patientId}/treatments`, serializeTreatment(treatment))
